(() => {
  function initializeInstallations() {
    document.querySelectorAll('[data-case-carousel]').forEach(root => {
      if (root.dataset.casesReady) return;
      root.dataset.casesReady = 'true';
      const track = root.querySelector('[data-case-track]');
      const cards = Array.from(track.children);
      const previous = root.querySelector('[data-case-prev]');
      const next = root.querySelector('[data-case-next]');
      const count = root.querySelector('[data-case-count]');
      const controls = root.querySelector('.gh-case-controls');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const distance = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        const viewport = track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() })).filter(({rect}) => Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left) >= rect.width / 2);
        const first = (visible[0]?.index || 0) + 1;
        const last = (visible.at(-1)?.index ?? first - 1) + 1;
        count.textContent = `${first === last ? first : `${first}–${last}`} / ${cards.length}`;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= maximum - 2;
        controls.hidden = maximum <= 2;
      };
      const move = direction => track.scrollBy({ left: direction * distance(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);
      update();
    });
  }
  initializeInstallations();
  document.addEventListener('shopify:section:load', initializeInstallations);
})();
